import apiClient, { get, del } from './api';

export interface TenantName {
  tenantUuid: string;
  tenantName: string;
}
export interface LocationName {
  locationUuid: string;
  locationName: string;
}
export interface RouteName {
  routeUuid: string;
  routeName: string;
}

export interface AdminName {
  adminUuid: string;
  adminFullName: string;
  adminEmail: string;
}

export interface RouteName {
  routeUuid: string;
  routeName: string;
}

export interface AdminName {
  adminUuid: string;
  adminFullName: string;
  adminEmail: string;
}

// API endpoints
const ENDPOINTS = {
  TENANT_NAMES: '/admin/general/tenant/names',
  LOCATION_NAMES: '/admin/general/location/names',
  GET_FILE: (fileUuid: string) => `/admin/general/file/${fileUuid}`,
  GET_FILE_BY_PATH: (path: string) => `/files/${path}`,
  ROUTE_NAMES: '/admin/general/route/names',
  ADMIN_NAMES:(locationUuid: string) => `/admin/general/admin-name/account/${locationUuid}`,
  DELETE: (id: string) => `/admin/general/file/${id}`,
};

// Response types
interface ListResponse<T> {
  data: T[];
}

interface DetailResponse<T> {
  data: T;
}
export const commonService = {
  // Get list tenant names
  getListTenantNames: () => {
    return get<ListResponse<TenantName>>(ENDPOINTS.TENANT_NAMES);
  },
  getListLocationNames: () => {
    return get<ListResponse<LocationName>>(ENDPOINTS.LOCATION_NAMES);
  },
    getFileUpload: (id: string) => {
    return get<DetailResponse<{ url: string }>>(ENDPOINTS.GET_FILE(id));
  },
   getFileByPath: (path: string) => {
    return get<DetailResponse<{ url: string }>>(ENDPOINTS.GET_FILE_BY_PATH(path));
  },
  getListRouteNames: (params?: { locationUuid?: string}) => {
    return get<ListResponse<RouteName>>(ENDPOINTS.ROUTE_NAMES, params);
  },
  getListAdminNames: (locationUuid: string) => {
    return get<ListResponse<AdminName>>(ENDPOINTS.ADMIN_NAMES(locationUuid));
  },
  deleteFileUpload: (id: string) => {
    return del<void>(ENDPOINTS.DELETE(id));
  },
};

export const uploadFile = (url: string, file: File, type: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  return apiClient.post(
    url,
    formData,
    {
      baseURL: import.meta.env.VITE_API_UPLOAD_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  ).then(res => res.data);
};